import styled from 'styled-components';
import { fade } from '@material-ui/core';

export const RoundedCard = styled.div`
    padding: ${props => props.theme.spacing(2)}px;
    background: ${props => fade(props.theme.palette.success.main, 0.16)};
    border-radius: 30px 10px 10px 10px;
    max-width: 500px;
    width: 100%;
`;